import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION1: PdfComponent = {
  type: 'section',
  id: 's1',
  title: '1. Definitions and interpretation',
  content: [
    {
      type: 'altText',
      id: 's1agreement',
      content: ['In this Agreement, unless the context requires otherwise:'],
      boldFirst: false,
    },
    {
      type: 'bulletList',
      id: 's1bullets',
      bulletType: 'dot',
      content: [
        {
          copy: {
            type: 'altText',
            id: '1act',
            content: [
              'The Act, the CCA',
              ' means the Consumer Credit Act 1974 (as amended from time to time) and any regulations made pursuant to it;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1affiliate',
            content: [
              'Affiliate',
              ' means any entity that directly or indirectly Controls, is Controlled by, or is under common Control with, another entity;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1agreement',
            content: [
              'Agreement',
              ' means this Agreement and each of its Schedules, as amended or restated from time to time;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1applicable',
            content: [
              'Applicable Law',
              " means the CCA, CONC, DISP, the DPA, FSMA, the CCR and all other statutes, case law, directions from regulators, regulations, rules, codes of practice, lending guidelines and guidance issued by any applicable regulator, trade association or government department (including but not limited to, the Finance and Leasing Association, the Information Commissioner's Office, the Department for Business, Energy and Industrial Strategy (BEIS), the Financial Conduct Authority, the Prudential Regulation Authority and any successor regulator and the Financial Ombudsman Service) as may be in force from time to time and which are applicable to the subject matter of this Agreement;",
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1appportal',
            content: [
              'Application Portal',
              ' means the electronic system operated or authorised by Kanda (including any system made available by a lender) that allows a Customer to apply for a Credit Agreement in order to fund purchases from a Retailer.',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1authorised',
            content: [
              'Authorised Salespersons',
              " means an individual authorised by the Subscriber to offer credit facilities available via Kanda's panel of lenders;",
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1bribery',
            content: [
              'Bribery Laws',
              ' means the Bribery Act 2010 and all other applicable UK legislation, statutory instruments and regulations in relation to bribery or corruption and any similar or equivalent legislation in any other relevant jurisdiction;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1business',
            content: [
              'Business Day',
              ' means a day other than a Saturday, Sunday or public holiday in England;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1cancelled',
            content: [
              'Cancelled Loans',
              " means loans where the Customer's Credit Agreement has been cancelled or refunded (in whole or in part), for whatever reason, such that Kanda owes a lender some or all of the loan amount under or in relation to that Credit Agreement. Where reference is made to the amount of a Cancelled Loan that has been cancelled in part only, the amount shall be the amount so cancelled;",
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1ccr',
            content: [
              'CCR',
              ' means the Consumer Contracts (Information, Cancellation and Additional Charges) Regulations 2013;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1commencement',
            content: ['Commencement', ' Date means {{CURRENT_DATE}}'],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1copleted',
            content: [
              'Completed Loans',
              ' means the execution of a Credit Agreement whereby a lender has funded Kanda for providing the goods and/or services to the relevant Customer;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1conc',
            content: [
              'CONC',
              ' means the Consumer Credit Sourcebook chapter of the FCA Handbook;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1confidential',
            content: [
              'Confidential Information',
              " means any information, however conveyed or presented (whether disclosed orally or in writing), that relates to the business, affairs, operations, customers, members, processes, budgets, pricing policies, product information, strategies, developments, trade secrets, know-how, personnel and suppliers of a party or any of its Affiliates, together with all information derived from any such information and any other information clearly designated by a party as being confidential to it (whether or not it is marked 'confidential'), or which ought reasonably be considered to be confidential;",
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1control',
            content: [
              'Control',
              ' means the beneficial ownership of more than 50% of the issued share capital of a company or the legal power to direct or cause the direction of the management of the company, and Controls, Controlled and under common Control shall be interpreted accordingly;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1credita',
            content: [
              'Credit Agreement',
              " means an agreement between a lender and a Customer in such form as may be supplied by the lender from time to time, which is entered into between the lender and a Customer for the purposes of financing a Customer's purchase of goods and services from the Subscriber;",
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1credit',
            content: [
              'Credit Facilities',
              " means credit facilities arranged through Kanda's panel of lenders from time to time whereby Customers may obtain Permitted Goods and Services using Credit Agreements, and Credit Facility shall be construed accordingly;",
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1customer',
            content: [
              'Customer',
              ' means a business or consumer customer of the Subscriber;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1customerapp',
            content: [
              'Customer Application',
              ' means a proposal for finance submitted on behalf of a prospective Customer;',
            ],
          },
        },

        {
          copy: {
            type: 'altText',
            id: '1data',
            content: [
              'Data Privacy Laws',
              " means all laws that relate to data protection, privacy, the use of information relating to individuals, and/or the information rights of individuals and all laws implementing them, in each case as may be replaced, extended or amended, including, without limitation, the General Data Protection Regulation (EU) 2016/679 as amended as the UK GDPR, the Data Protection Act 2018 and the Privacy and Electronic Communications (EC Directive) Regulations 2003, as well as all applicable formal or informal guidance, rules, requirements, directions, guidelines, recommendations, advice, codes of practice, policies, measures or publications of the Information Commissioner's Office, other relevant regulator, and/or relevant industry body, in each case in any relevant jurisdiction(s);",
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1dpa',
            content: ['DPA', ' means the Data Protection Act 2018;'],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1disp',
            content: [
              'DISP',
              ' means the Dispute Resolution: Complaints Sourcebook chapter of the FCA Handbook;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1exception',
            content: [
              'Exception',
              ' has the meaning given to it in the relevant Broker Agreement;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1exf',
            content: [
              'Exceptions File',
              ' means a daily file containing a list of Exceptions;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1fca',
            content: ['FCA', ' means the Financial Conduct Authority;'],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1fme',
            content: [
              'Force Majeure Event',
              " means any cause affecting the performance by a Party of any of its obligations under this Agreement which is beyond its reasonable control and which, by its nature, could not have been foreseen or, if foreseeable, was unavoidable (but excluding the consequences of any failure by Kanda to comply with its business continuity plan, any duty to comply with Applicable Law, any cause which is attributable to the party's or its Affiliates' wilful act or negligence, any cause which merely increases its cost of performing its obligations, any industrial dispute relating to Kanda or its personnel or any analogous failure in Kanda's supply chain);",
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1fsma',
            content: [
              'FSMA',
              ' means the Financial Services and Markets Act 2000;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1gaap',
            content: [
              'GAAP',
              ' means generally accepted accounting principles, standards and practices in the UK, including IFRS;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1group',
            content: [
              'Group',
              ' in relation to any person, means such person and any corporations which are holding companies or subsidiaries or subsidiary undertakings (as such terms are defined in the Companies Act 2006) of it or of any such holding company;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1goodp',
            content: [
              'Good Industry Practice',
              ' means the exercise of that degree of skill, diligence, prudence, foresight and operating practice which, at the relevant time, would reasonably and ordinarily be expected from a skilled and experienced person engaged in the same or a similar business;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1kpg',
            content: [
              'Kanda Procedure Guide',
              ' means the procedure guide issued by Kanda relating to Credit Facilities provided through its panel of lenders, as set out in Schedule 3 (Kanda Procedure Guide) to this Agreement (or as notified to the Subscriber or as amended by Kanda from time to time);',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1ins',
            content: [
              'Insolvency Event',
              ' means, in relation to an entity, that the entity:',
            ],
          },
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'is dissolved (other than pursuant to a consolidation, amalgamation or merger);',
              },
              {
                copy: 'becomes insolvent or is unable to pay its debts or fails or admits in writing its inability generally to pay its debts as they become due;',
              },
              {
                copy: 'makes a general assignment, arrangement or composition with or for the benefit of its creditors;',
              },
              {
                copy: "institutes or has instituted against it, by a regulator, supervisor or any similar official with primary insolvency, rehabilitative or regulatory jurisdiction over it in the jurisdiction of its incorporation or organisation or the jurisdiction of its head or home office, a proceeding seeking a judgment of insolvency or bankruptcy or any other relief under any bankruptcy or insolvency law or other similar law affecting creditors' rights, or a petition is presented for its winding-up or liquidation by it or such regulator, supervisor or similar official;",
              },
              {
                copy: "has instituted against it a proceeding seeking a judgment of insolvency or bankruptcy or any other relief under any bankruptcy or insolvency law or other similar law affecting creditors' rights, or a petition is presented for its winding-up or liquidation, and, in the case of any such proceeding or petition instituted or presented against it, such proceeding or petition is instituted or presented by a person or entity not described in paragraph (d) above and:",
                sublist: {
                  bulletType: 'disc',
                  content: [
                    {
                      copy: 'results in a judgment of insolvency or bankruptcy or the entry of an order for relief or the making of an order for its winding-up or liquidation; or',
                    },
                    {
                      copy: 'is not dismissed, discharged, stayed or restrained in each case within 30 days of the institution or presentation thereof;',
                    },
                  ],
                },
              },
              {
                copy: 'has a resolution passed for its winding-up, official management or liquidation (other than pursuant to a consolidation, amalgamation or merger);',
              },
              {
                copy: 'seeks or becomes subject to the appointment of an administrator, provisional liquidator, conservator, receiver, trustee, custodian or other similar official for it or for all or substantially all its assets (other than, for so long as it is required by law or regulation not to be publicly disclosed, any such appointment which is to be made, or is made, by a person or entity described in paragraph (d) above);',
              },
              {
                copy: 'has a secured party take possession of all or substantially all its assets or has a distress, execution, attachment, sequestration or other legal process levied, enforced or sued on or against all or substantially all its assets and such secured party maintains possession, or any such process is not dismissed, discharged, stayed or restrained, in each case within 30 days thereafter;',
              },
              {
                copy: 'causes or is subject to any event with respect to it which, under the applicable laws of any jurisdiction, has an analogous effect to any of the events specified in paragraphs (a) to (h) above; or',
              },
              {
                copy: ' takes any action in furtherance of, or indicating its consent to, approval of, or acquiescence in, any of the foregoing acts.',
              },
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1ipr',
            content: [
              'Intellectual Property Rights',
              ' means any of the following rights existing in any part of the world: all patents, utility models, rights to inventions, plant variety rights, copyright and neighbouring and related rights, moral rights, rights in designs, semiconductor topography rights, trade and service marks, trade names, logos, rights in get-up and trade dress, goodwill and the right to sue for passing off or unfair competition, domain name registrations, database rights and rights in information (including know-how) and all other intellectual property rights, in each case whether registered or unregistered; applications to register any of those rights; rights to apply for and be granted renewals or extensions of, and rights to claim priority from, any of those rights; and any similar or equivalent rights;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1kandadata',
            content: [
              'Kanda Data',
              ' means any data including Personal Data, information, text, visual or graphic representations and other materials in any medium or format owned by or licensed to Kanda or any of its Affiliates (including any information relating to Customers and/or Retailers and used by the Subscriber, its Affiliates or its sub-contractors in the provision of the Services and performance of its obligations in connection with this Agreement);',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1liab',
            content: [
              'Liability',
              ' includes all losses, claims, damages, liabilities, fines, interest, penalties, costs, charges, expenses, demands and legal and other professional costs reasonably and properly incurred (calculated on a full indemnity basis);',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1mae',
            content: [
              'Material Adverse Effect',
              ' means a material adverse effect on or material adverse change in:',
            ],
          },
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'the financial condition, assets, prospects, reputation or business of Kanda or any Retailer, or the consolidated financial condition, assets, prospects, reputation or business of either the Kanda Group or the Retailer Group;',
              },
              {
                copy: "the financial condition, assets, prospects, reputation or business of any lender within Kanda's panel, or the consolidated financial condition, assets, prospects, reputation or business of that lender's group;",
              },
              {
                copy: 'the ability of the Subscriber to perform and comply with its obligations under this Agreement; or',
              },
              {
                copy: 'the validity, legality or enforceability of this Agreement.',
              },
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1mb',
            content: [
              'Material Breach',
              ' means a breach (including an anticipatory breach) which is not minimal or trivial in its consequences to the non-breaching party. A series of breaches that individually may be considered minimal or trivial in their consequences may in aggregate be more than minimal or trivial and, therefore, together amount to a Material Breach. In deciding whether any breach is a Material Breach no regard shall be had to whether it occurs by some accident, mishap, mistake or misunderstanding;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1msa',
            content: [
              'MSA Offence',
              ' shall have the meaning in clause 11.1(a);',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1pd',
            content: [
              'Personal Data',
              ' has the meaning set out in the Data Privacy Laws;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1pdb',
            content: [
              'Personal Data Breach',
              ' has the meaning set out in the Data Privacy Laws;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1pgs',
            content: [
              'Permitted Goods and Services',
              ' means the list of goods and/or services that are notified by Kanda to the Subscriber from time to time as being eligible for finance under a Credit Agreement, and shall be the only goods and/or services eligible for such finance;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1pl',
            content: [
              'Permitted Location',
              ' means any premises Kanda determines to be relating to Subscriber;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1psc',
            content: [
              'Permitted Sales Channels',
              ' means the list of permitted sales channels set out in Schedule 2 (Permitted Goods and Services and Permitted Sales Channels) to this Agreement (or as notified to Kanda or as amended by Kanda from time to time);',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1pci',
            content: [
              'Pre-Contract Information',
              ' means the pre-contract credit information in the format of the Standard European Consumer Credit Information (SECCI) and the adequate explanations which are required to be provided to a Customer in accordance with the requirements in CONC 4.2;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1process',
            content: [
              'Processing',
              ' has the meaning set out in the Data Privacy Laws, and Process, Processed and Processes shall be construed accordingly;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1retailer',
            content: [
              'Retailer',
              ' has the meaning set out in the relevant Broker Agreement;',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1term',
            content: [
              'Term',
              ' means the Initial Term and any Extension Period (if applicable);',
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1trans',
            content: [
              'Transaction',
              " means any Credit Agreement (approved, referred or declined) made using the products provided by or through a lender within Kanda's panel;",
            ],
          },
        },
        {
          copy: {
            type: 'altText',
            id: '1vat',
            content: [
              'VAT',
              ' means United Kingdom value added tax as defined by the Value Added Tax Act 1994 or any other tax imposed in substitution for it.',
            ],
          },
        },
      ],
    },
    {
      type: 'altText',
      id: 's1inagreement',
      content: ['In this Agreement:'],
    },
    {
      type: 'bulletList',
      id: 's1sbullets',
      bulletType: 'alpha',
      content: [
        {
          copy: 'a reference to this Agreement includes its schedules, appendices and annexes (if any);',
        },
        {
          copy: 'the table of contents, background section and any clause, schedule or other headings in this Agreement are included for convenience only and shall have no effect on the interpretation of this Agreement;',
        },
        {
          copy: "a reference to a party includes that party's personal representatives, successors and permitted assigns;",
        },
        {
          copy: "a reference to a 'person' includes a natural person, corporate or unincorporated body (in each case whether or not having separate legal personality) and that person's personal representatives, successors and permitted assigns;",
        },
        {
          copy: "a reference to a 'company' includes any company, corporation or other body corporate, wherever and however incorporated or established;",
        },
        {
          copy: 'a reference to a gender includes each other gender;',
        },
        {
          copy: 'words in the singular include the plural and vice versa;',
        },
        {
          copy: "any words that follow 'include', 'includes', 'including', 'in particular' or any similar words and expressions shall be construed as illustrative only and shall not limit the sense of any word, phrase, term, definition or description preceding those words;",
        },
        {
          copy: "a reference to 'writing' or 'written' includes any method of reproducing words in a legible and non-transitory form;",
        },
        {
          copy: 'without prejudice to the provisions of Schedule 1 (Data Protection), a reference to legislation is a reference to that legislation as amended, extended, re-enacted or consolidated from time to time; and',
        },
        {
          copy: 'a reference to any English action, remedy, method of judicial proceeding, court, official, legal document, legal status, legal doctrine, legal concept or thing shall, in respect of any jurisdiction other than England, be deemed to include a reference to that which most nearly approximates to the English equivalent in that jurisdiction.',
        },
      ],
    },
  ],
};
